import {
  CardHeader,
  Checkbox,
  makeStyles,
  MenuItem,
  Switch,
} from "@material-ui/core";
import clsx from "clsx";
import _ from "lodash";
import * as React from "react";
import { useHistory } from "react-router";

import { useMemo } from "react";

import DropdownBox from "../../../components/Dropdown/DropdownBox";
import { EmptyIcon } from "../../../components/icons/themes/logos";
import { CTAButton } from "../../../components/Table/AddValueButton";
import {
  RequestableSaasDestination,
  SaaSDestination,
  WarehouseDestination,
} from "../../../destinations/destinations";
import useArrayOfDestinations from "../../../hooks/useArrayOfDestinations";

const useStyle = makeStyles((theme) => ({
  menuItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  menuHeader: {
    backgroundColor: theme.palette.grey[50],
    borderBottomColor: theme.palette.grey[200],
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
    padding: theme.spacing(2),
  },
}));

interface DestinationsMenuProps {
  menuId: string;
  header?: string;
  anchorEl?: HTMLElement | null;
  onClear?: () => void;
  onClose: () => void;
  onToggle: (destinationId: string, checked: boolean) => void;
  selectedDestinations: string[];
  configurableDestinations: Record<
    string,
    | SaaSDestination
    | RequestableSaasDestination
    | WarehouseDestination
    | undefined
  >;
  showAsCheckbox?: boolean;
  segmentCompatible?: boolean;
  show: boolean;
}

export default function DestinationsMenu({
  menuId,
  anchorEl,
  onToggle,
  selectedDestinations,
  configurableDestinations,
  showAsCheckbox,
  segmentCompatible,
  onClose,
  show,
  header,
}: DestinationsMenuProps) {
  const history = useHistory();
  const classes = useStyle();
  const allDestinations = useArrayOfDestinations();
  const destList = useMemo(() => {
    return _(allDestinations).sortBy("name").value();
  }, [allDestinations]);

  return (
    <>
      <DropdownBox
        id={menuId}
        anchorEl={anchorEl}
        handleClose={onClose}
        show={show}
        actionLabel={undefined}
      >
        {destList.length === 0 ? (
          <MenuItem>
            <CTAButton
              text="Configure a Destination"
              onClick={() => history.push("/destinations/apps")}
            />
          </MenuItem>
        ) : (
          <CardHeader
            className={clsx(classes.menuHeader)}
            title={header || "Edit Destinations"}
          />
        )}
        {destList.length > 0 &&
          destList.map((configuredDestination) => {
            const checked = selectedDestinations.some(
              (d) => d === configuredDestination.id
            );

            const disabled = !configuredDestination.enabled;

            const Logo =
              configurableDestinations[configuredDestination.type_slug]
                ?.logoSquare || EmptyIcon;

            const destinationMetaData = configurableDestinations[
              configuredDestination.type_slug
            ] as SaaSDestination;

            return (
              <MenuItem
                onClick={() => onToggle(configuredDestination.id, !checked)}
                className={clsx(classes.menuItem)}
                disabled={disabled}
                key={configuredDestination.id}
              >
                <div className="flex items-start">
                  <span className="mr-2">
                    <Logo />
                  </span>
                  <div>
                    {destinationMetaData?.name}
                    {destinationMetaData?.supportsMultiConfig && (
                      <>
                        <br />
                        <small>
                          {destinationMetaData.multiConfigLabel}:{" "}
                          {configuredDestination.instance_name}
                        </small>
                      </>
                    )}
                  </div>
                </div>
                {showAsCheckbox ? (
                  <Checkbox
                    checked={checked}
                    disabled={segmentCompatible || disabled}
                    onChange={_.noop}
                  />
                ) : (
                  <Switch
                    checked={checked}
                    disabled={segmentCompatible || disabled}
                    onChange={_.noop}
                  />
                )}
              </MenuItem>
            );
          })}
      </DropdownBox>
    </>
  );
}
